module.exports = __webpack_public_path__ + "img/actOutline.1a86f963.svg";